export default "__VITE_ASSET__CINcCY1C__"